import {createFeatureSelector, createSelector} from '@ngrx/store';
import {State} from './destination.stop-many.reducer';
import {Destination} from '../../../services/api/destinations/destination.model';

export const stopManyDestinationsFeatureKey = 'stopManyDestinations';
export const featureSelector = createFeatureSelector<State>(stopManyDestinationsFeatureKey);

export const getStopManyDestinationsRecord = createSelector(
  featureSelector,
  (state: State): Destination[] => state.record
);

export const getStopManyDestinationsLoaded = createSelector(
  featureSelector,
  (state: State): boolean => state.loaded
);

export const getStopManyDestinationsLoading = createSelector(
  featureSelector,
  (state: State): boolean => state.loading
);

export const getStopManyDestinationsError = createSelector(
  featureSelector,
  (state: State): any => state.error
);
